export enum GlobalText {
	DeleteImage = "C4409D76-9AC0-4647-A0B6-1A74889F04F6",
	SelectImage = "38CCC1EA-480F-48D9-AB87-88674A76B42B",
	SubmitImage = "5259DCDB-0251-4DEC-8B5C-4D7C39695E48",
}
